
import SvgIcon from "@/components/common/SvgIcon.vue"
import {computed, ref, watchEffect} from "vue";
import store from "@/store";
import {MemberDataType} from "@/store/store.type";
import {getVICPrefix} from "@/utils/general";
import {LinkType} from "@/utils/general.type";

const vicBg = require("@/assets/image/card-bg-vic.png");
const blackVicBg = require("@/assets/image/card-bg-vic-black.png");
const goldVicBg = require("@/assets/image/card-bg-vic-gold.png");
const bvicBg = require("@/assets/image/card-bg-bvic.png");
const tvicBg = require("@/assets/image/card-bg-tvic.png");

const QRCode = require('qrcode');

const links: LinkType[] = [
  {
    external: false, icon: "star", link: "reward", text: "rewards",
  },
  {
    external: false, icon: "diamond", link: "privilege", text: "privileges",
  },
  {
    external: false, icon: "gift", link: "offer", text: "birthday-offer",
  },
];

export default {
  name: 'MemberInfoSection',
  components: {SvgIcon},
  setup() {
    const type = computed(() => store.state.selectedType);
    const memberData = computed(() => store.state.memberData);
    const qrCode = ref('');

    const generateQRCode = (text?: string) => {
      if (!text) {
        qrCode.value = '';
      } else {
        QRCode.toDataURL(text, {
          // scale: 2,
          width: 90,
          margin: 1,
        }).then((url: string) => {
          qrCode.value = url;
        });
      }
    }

    // if memberData = [TVIC, VIC, BVIC]
    // memberMap = [1, 2, 0] <- -1 if not exist
    // mapping the index of the array for [VIC, BVIC, TVIC]
    const memberMap = computed(() => {
        return [2, 3, 6].map((memberClub: number) =>
              memberData.value.findIndex((d: MemberDataType) => {
                if (!d) return false;
                return d.ProfileDetails.MemberClub === memberClub;
              })
          )
        }
    )

    const selectedMemberData = computed(() =>
        memberData.value[memberMap.value[type.value]]
    )


    watchEffect(() => {
      // change selected type if user is not at that member club
      console.log("type", type.value);
      if (memberData.value.length === 0) {
        return;
      }
      if (memberMap.value[type.value] >= 0) {
        return;
      }
      // find the first member club user is.
      const dataArrayNumber = memberMap.value.find(m => m >= 0);
      if (dataArrayNumber !== undefined) {
        store.commit('onTypeChange', dataArrayNumber);
      }
    });

    const cardImage = computed(() => {
      if (type.value === 1) {
        return bvicBg;
      } else if (type.value === 2) {
        return tvicBg;
      } else {
        const memberTier = selectedMemberData.value?.ProfileDetails?.MemberTier?.toLowerCase();
        if (memberTier === "gold") {
          return goldVicBg;
        } else if (memberTier === "black") {
          return blackVicBg;
        } else {
          return vicBg;
        }
      }
    })

    const onMemberTypeChange = (type: number) => {
      store.commit('onTypeChange', type)
    }

    watchEffect(() => {
      generateQRCode(selectedMemberData.value?.QrCode);
    });


    const onLogout = () => {
      store.commit('onLogout');
      // router.push({
      //   path: '/',
      //   params: {
      //     lang: i18n.global.locale
      //   }
      // });
    }

    return {
      type,
      getVICPrefix,
      memberMap,
      onMemberTypeChange,
      onLogout,
      selectedMemberData,
      cardImage,
      links,
      qrCode
    }
  }
}
